import { render, staticRenderFns } from "./LaravelPagination.vue?vue&type=template&id=b8d142c2&"
import script from "./LaravelPagination.vue?vue&type=script&lang=js&"
export * from "./LaravelPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports